export const SITE_DISPLAY_NAME = "Dream Sports";
export const SITE_DOMAIN_LABEL = "DreamSports.com";

export const FAQ_INTRO_COPY = `Nothing compares to online betting at ${SITE_DISPLAY_NAME}. We've got the best odds, and hundreds of sports for you to choose from.`;

export const COPYRIGHT_LINE = (year = new Date().getFullYear()) =>
  `${SITE_DOMAIN_LABEL} © ${year} All Rights Reserved.`;

/** User-visible labels that replaced legacy Mobius naming. */
export const LIVE_SECTION_LABEL = "Live";
